import type { QueryClient } from '@tanstack/react-query'

const TOOLBAR_QUERY_PREFIX = '/api/v1/toolbar'

export function invalidateShipmentHistory(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey[0]
      return typeof key === 'string' && key.startsWith(TOOLBAR_QUERY_PREFIX)
    },
  })
}
